import { render, staticRenderFns } from "./ChatRoomDropdown.vue?vue&type=template&id=4f87ed38&scoped=true"
import script from "./ChatRoomDropdown.vue?vue&type=script&lang=js"
export * from "./ChatRoomDropdown.vue?vue&type=script&lang=js"
import style0 from "./ChatRoomDropdown.vue?vue&type=style&index=0&id=4f87ed38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f87ed38",
  null
  
)

export default component.exports